export default "__VITE_ASSET__DE4QPrdl__"